import Basic from '@/components/page/Basic.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'

export default{
	extends: Basic,
	data: function () {
		return {
			ytd: {
				penerimaan:{ 
                    bunga_deposito:[], bunga_giro:[], bunga_notpool:[], penjualan:[], total_penerimaan:[], 
                    penjualan_data:[], bunga_deposito_data:[], bunga_notpool_data:[], bunga_giro_data:[],
                }, 
				persentase_penerimaan:{ 
                    penjualan:[], cash:[], non_cash:[], cash_per_day:[], non_cash_per_day:[], rata_rata_per_day:[],
                    penjualan_data:[], cash_data:[], non_cash_data:[], cash_per_day_data:[], non_cash_per_day_data:[], rata_rata_per_day_data:[] 
                }, 
                pengeluaran:{ 
                    pengeluaran:[], pajak_notpool:[], biaya_administrasi_bank:[], pajak_giro:[], bank_charge:[], total_pengeluaran:[],
                    pengeluaran_data:[], pajak_notpool_data:[], biaya_administrasi_bank_data:[], pajak_giro_data:[], bank_charge_data:[], total_pengeluaran_data:[],  
                },
                persentase_pengeluaran:{ 
                    pengeluaran:[], pengeluaran_per_bank:[], biaya_administrasi_bank:[], pajak_giro:[], bank_charge:[], 
                    pengeluaran_data:[], pengeluaran_per_bank_data:[], biaya_administrasi_bank_data:[], pajak_giro_data:[], bank_charge_data:[], 
                },

                piechart_persentase_pengeluaran:{ pengeluaran:[], pengeluaran_per_bank:[], biaya_administrasi_bank:[], pajak_giro:[], bank_charge:[], },

                piechart_persentase_penerimaan:{ penjualan:[], cash:[], non_cash:[], },

                summary: {
                    penerimaan: {
                        barchart_bunga_deposito:[], barchart_bunga_giro:[],barchart_bunga_notpool:[],barchart_penjualan:[],
                    },
                    pengeluaran: {
                        barchart_total_pengeluaran:[],barchart_bank_charge:[],barchart_pajak_giro:[],barchart_biaya_administrasi_bank:[],barchart_pajak_notpool:[],barchart_pengeluaran:[],
                    },
                    penerimaan_persentase: {
                        barchart_cash:[],barchart_cash_per_day:[],barchart_non_cash:[],barchart_non_cash_per_day:[],barchart_penjualan:[],barchart_rata_rata_day:[],
                    },
                    pengeluaran_persentase: {
                        barchart_bank_charge:[],barchart_biaya_administrasi_bank:[],barchart_pajak_giro:[],barchart_pengeluaran:[],barchart_pengeluaran_per_bank:[],
                    },
                    piechart_pengeluaran_persentase: {
                        bank_charge:[], biaya_administrasi_bank:[], pajak_giro:[], pengeluaran:[],pengeluaran_per_bank:[]
                    },
                    piechart_penerimaan_persentase: {
                        cash:[], non_cash:[], penjualan:[],
                    }

                },

			}, 
            years_select: [],
            years_checkbox: [],
            selected_current_year: '',
            penerimaan_label: {
                penjualan: [], bunga_deposito:[], bunga_giro:[], bunga_notpool:[],
            },
            persentase_penerimaan_label: {
                penjualan: [], cash:[], non_cash:[], cash_per_day:[], non_cash_per_day:[], rata_rata_per_day:[],
            },
            pengeluaran_label:{ 
                pengeluaran:[], pajak_notpool:[], biaya_administrasi_bank:[], pajak_giro:[], bank_charge:[], total_pengeluaran:[],
            },
            persentase_pengeluaran_label:{ 
                pengeluaran:[], pengeluaran_per_bank:[], biaya_administrasi_bank:[], pajak_giro:[], bank_charge:[], 
            },
			loading: { table:true, chart: false },
		}	
	},
    methods:{
	
		async loadData(param_year='') {  
            let currentYear = new Date().getFullYear() + '';     
            this.selected_current_year = (param_year == "" ? currentYear : param_year );  
			let url = Config().apiURL + "/finance/treasury?year="+param_year;//period=monthly&pso=bypso&date-range-start=" + Penanggalan().tahunSekarang + "&date-range-end=" + Penanggalan().kemarin;
			//console.log(url);
            this.loading.chart = true
            await AxiosWithJar().get(url).then(result => {
				//if (result.data.length) {
                    this.loading.chart = false
                    try {
					this.ytd.penerimaan = {
						//bunga_deposito: this.processBarChart(result.data.penerimaan_bunga_deposito, "NamaPenerimaan", "", "Nilai", false, "Pengeluaran", "", 1000000000, 2, Rainbow, false, false, false, true),
                        //bunga_giro: this.processBarChart(result.data.penerimaan_bunga_giro, "NamaPenerimaan", "", "Nilai", false, "Pengeluaran", "", 1000000000, 2, Rainbow, false, false, false, true),

                        bunga_deposito: this.processBarChart(result.data.penerimaan_bunga_deposito, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
						bunga_giro: this.processBarChart(result.data.penerimaan_bunga_giro, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        bunga_notpool: this.processBarChart(result.data.penerimaan_bunga_notpool, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        penjualan: this.processBarChart(result.data.penerimaan_penjualan, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        
                        penjualan_data: result.data.penerimaan_penjualan,
                        bunga_giro_data: result.data.penerimaan_bunga_giro,
                        bunga_notpool_data: result.data.penerimaan_bunga_notpool,
                        bunga_deposito_data: result.data.penerimaan_bunga_deposito,
                    };

                    this.ytd.pengeluaran = {
						//bunga_deposito: this.processBarChart(result.data.penerimaan_bunga_deposito, "NamaPenerimaan", "", "Nilai", false, "Pengeluaran", "", 1000000000, 2, Rainbow, false, false, false, true),
                        //bunga_giro: this.processBarChart(result.data.penerimaan_bunga_giro, "NamaPenerimaan", "", "Nilai", false, "Pengeluaran", "", 1000000000, 2, Rainbow, false, false, false, true),

                        pengeluaran: this.processBarChart(result.data.pengeluaran_pengeluaran, "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
						biaya_administrasi_bank: this.processBarChart(result.data.pengeluaran_biaya_administrasi_bank, "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        pajak_giro: this.processBarChart(result.data.pengeluaran_pajak_giro, "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        pajak_notpool: this.processBarChart(result.data.pengeluaran_pajak_notpool, "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        bank_charge: this.processBarChart(result.data.pengeluaran_bank_charge, "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        
                        pengeluaran_data:result.data.pengeluaran_pengeluaran, 
                        pajak_notpool_data:result.data.pengeluaran_pajak_notpool, 
                        biaya_administrasi_bank_data:result.data.pengeluaran_biaya_administrasi_bank, 
                        pajak_giro_data:result.data.pengeluaran_pajak_giro, 
                        bank_charge_data:result.data.pengeluaran_bank_charge, 
                        //total_pengeluaran_data:, 
                    };

                    this.ytd.persentase_penerimaan = {
                        penjualan: this.processBarChart(result.data.persentase_penerimaan_penjualan, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
						cash: this.processBarChart(result.data.persentase_penerimaan_cash, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        non_cash: this.processBarChart(result.data.persentase_penerimaan_non_cash, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        cash_per_day: this.processBarChart(result.data.persentase_penerimaan_cash_per_day, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        non_cash_per_day: this.processBarChart(result.data.persentase_penerimaan_non_cash_per_day, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        rata_rata_per_day: this.processBarChart(result.data.persentase_penerimaan_rata_rata_day, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        
                        penjualan_data:result.data.persentase_penerimaan_penjualan, 
                        cash_data:result.data.persentase_penerimaan_cash, 
                        non_cash_data:result.data.persentase_penerimaan_non_cash, 
                        cash_per_day_data:result.data.persentase_penerimaan_cash_per_day, 
                        non_cash_per_day_data:result.data.persentase_penerimaan_non_cash_per_day, 
                        rata_rata_per_day_data:result.data.persentase_penerimaan_rata_rata_day,
                    };

                    this.ytd.persentase_pengeluaran = {
                        pengeluaran: this.processBarChart(result.data.persentase_pengeluaran_pengeluaran ? result.data.persentase_pengeluaran_pengeluaran: [], "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
						pengeluaran_per_bank: this.processBarChart(result.data.persentase_pengeluaran_pengeluaran_per_bank ? result.data.persentase_pengeluaran_pengeluaran_per_bank : [], "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        biaya_administrasi_bank: this.processBarChart(result.data.persentase_pengeluaran_biaya_administrasi_bank ? result.data.persentase_pengeluaran_biaya_administrasi_bank: [], "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        pajak_giro: this.processBarChart(result.data.persentase_pengeluaran_pajak_giro ? result.data.persentase_pengeluaran_pajak_giro: [], "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
                        bank_charge: this.processBarChart(result.data.persentase_pengeluaran_bank_charge ? result.data.persentase_pengeluaran_bank_charge: [], "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true),
					
                        pengeluaran_data: result.data.persentase_pengeluaran_pengeluaran, 
                        pengeluaran_per_bank_data:result.data.persentase_pengeluaran_pengeluaran_per_bank, 
                        biaya_administrasi_bank_data:result.data.persentase_pengeluaran_biaya_administrasi_bank, 
                        pajak_giro_data:result.data.persentase_pengeluaran_pajak_giro, 
                        bank_charge_data:result.data.persentase_pengeluaran_bank_charge, 
                    };

                    this.ytd.piechart_persentase_pengeluaran = {
                        pengeluaran: result.data.piechart_persentase_pengeluaran_pengeluaran,
                        pengeluaran_per_bank: result.data.piechart_persentase_pengeluaran_pengeluaran_per_bank,
                        biaya_administrasi_bank: result.data.piechart_persentase_pengeluaran_biaya_administrasi_bank,
                        pajak_giro: result.data.piechart_persentase_pengeluaran_pajak_giro,
                        bank_charge: result.data.piechart_persentase_pengeluaran_bank_charge, 
                    }

                    this.ytd.piechart_persentase_penerimaan = {
                        penjualan: result.data.piechart_persentase_penerimaan_penjualan,
                        cash: result.data.piechart_persentase_penerimaan_cash,
                        non_cash: result.data.piechart_persentase_penerimaan_non_cash,
                    }

                   

                    this.penerimaanLabel(this.ytd.penerimaan.penjualan_data, "penjualan");
                    this.penerimaanLabel(this.ytd.penerimaan.bunga_deposito_data, "bunga_deposito");
                    this.penerimaanLabel(this.ytd.penerimaan.bunga_notpool_data, "bunga_notpool");
                    this.penerimaanLabel(this.ytd.penerimaan.bunga_giro_data, "bunga_giro");

                    this.penerimaanLabel(this.ytd.persentase_penerimaan.penjualan_data, "persentase_penerimaan_penjualan");
                    this.penerimaanLabel(this.ytd.persentase_penerimaan.cash_data, "persentase_penerimaan_cash");
                    this.penerimaanLabel(this.ytd.persentase_penerimaan.non_cash_data, "persentase_penerimaan_non_cash");
                    this.penerimaanLabel(this.ytd.persentase_penerimaan.cash_per_day_data, "persentase_penerimaan_cash_per_day");
                    this.penerimaanLabel(this.ytd.persentase_penerimaan.non_cash_per_day_data, "persentase_penerimaan_non_cash_per_day");
                    this.penerimaanLabel(this.ytd.persentase_penerimaan.rata_rata_per_day_data, "persentase_penerimaan_rata_rata_per_day");

                    this.pengeluaranLabel(this.ytd.pengeluaran.pengeluaran_data, "pengeluaran_data");
                    this.pengeluaranLabel(this.ytd.pengeluaran.pajak_notpool_data, "pajak_notpool_data");
                    this.pengeluaranLabel(this.ytd.pengeluaran.biaya_administrasi_bank_data, "biaya_administrasi_bank_data");
                    this.pengeluaranLabel(this.ytd.pengeluaran.pajak_giro_data, "pajak_giro_data");
                    this.pengeluaranLabel(this.ytd.pengeluaran.bank_charge_data, "bank_charge_data");

                    this.pengeluaranLabel(this.ytd.persentase_pengeluaran.pengeluaran_data, "persentase_pengeluaran_data");
                    this.pengeluaranLabel(this.ytd.persentase_pengeluaran.pengeluaran_per_bank_data, "persentase_pengeluaran_per_bank_data");
                    this.pengeluaranLabel(this.ytd.persentase_pengeluaran.biaya_administrasi_bank_data, "persentase_pengeluaran_biaya_administrasi_bank_data");
                    this.pengeluaranLabel(this.ytd.persentase_pengeluaran.pajak_giro_data, "persentase_pengeluaran_pajak_giro_data");
                    this.pengeluaranLabel(this.ytd.persentase_pengeluaran.bank_charge_data, "persentase_pengeluaran_bank_charge_data");
                    } catch(error) {
                        console.log(error);
                    }
                    this.years_checkbox = result.data.years_checkbox;
                    //this.years_select = result.data.years_select;
                    this.years_select = [];
                    for(let i in this.years_checkbox) {
                        let year = {value: (this.years_checkbox[i].Name + ''), name: (this.years_checkbox[i].Name + '')};
                        this.years_select.push(year);
                        //this.selected_current_year = this.years_checkbox[i].Name + '';
                        //console.log("year: " + JSON.stringify(year))
                    }
                    console.log("this.years_select: " + JSON.stringify(this.years_select));
				//}
                //console.log("result: " + JSON.stringify(result.data));
                //console.log("result: " + JSON.stringify(this.ytd.penerimaan.bunga_deposito));
                //console.log("result 2: " + JSON.stringify(result.data.penerimaan_bunga_deposito));

                /*
                this.ytd.penerimaan.bunga_deposito = {
                    labels : ["Jan","Feb","Mar","Apr","Mei"],
                    datasets: [
                        {
                            label: "BNI",
                            data: ["0.73", "0.27", "0.80", "1.47", "0.01"],
                            backgroundColor: "#852efe",
                            datalabels: {
                                display: false
                            }
                        },
                        {
                            label: "BSI",
                            data: ["0.10", "0.20", "0.30", "1.47", "0.51"],
                            backgroundColor: "#ff2ecb",
                            datalabels: {
                                display: false
                            }
                        },
                    ]
                } */
			})
		},

        async loadSummaryData() {   

			let url = Config().apiURL + "/finance/treasury-summary?";
            await AxiosWithJar().get(url).then(result => {
                /*
                this.ytd.summary.penerimaan = {
                    barchart_penjualan: this.processBarChart(result.data.summary.penerimaan.penjualan, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_bunga_deposito: this.processBarChart(result.data.summary.penerimaan.bunga_deposito, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_bunga_notpool: this.processBarChart(result.data.summary.penerimaan.bunga_notpool, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_bunga_giro: this.processBarChart(result.data.summary.penerimaan.bunga_giro, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                }

                this.ytd.summary.pengeluaran = {
                    barchart_total_pengeluaran:this.processBarChart(result.data.summary.pengeluaran.total_pengeluaran, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_bank_charge:this.processBarChart(result.data.summary.pengeluaran.bank_charge, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_pajak_giro:this.processBarChart(result.data.summary.pengeluaran.pajak_giro, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_biaya_administrasi_bank:this.processBarChart(result.data.summary.pengeluaran.biaya_administrasi_bank, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_pajak_notpool:this.processBarChart(result.data.summary.pengeluaran.pajak_notpool, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_pengeluaran:this.processBarChart(result.data.summary.pengeluaran.pengeluaran, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                }

                this.ytd.summary.penerimaan_persentase = {
                    barchart_cash:this.processBarChart(result.data.summary.penerimaan_persentase.cash, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_cash_per_day:this.processBarChart(result.data.summary.penerimaan_persentase.cash_per_day, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_non_cash:this.processBarChart(result.data.summary.penerimaan_persentase.non_cash, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_non_cash_per_day:this.processBarChart(result.data.summary.penerimaan_persentase.non_cash_per_day, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_penjualan:this.processBarChart(result.data.summary.penerimaan_persentase.penjualan, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_rata_rata_day:this.processBarChart(result.data.summary.penerimaan_persentase.rata_rata_day, "NamaPenerimaan", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                }
                */

                this.ytd.summary.piechart_penerimaan_persentase = {
                    cash:result.data.summary.penerimaan_persentase_pie.cash,
                    non_cash:result.data.summary.penerimaan_persentase_pie.non_cash,
                    penjualan:result.data.summary.penerimaan_persentase_pie.penjualan,
                }

                /*
                this.ytd.summary.pengeluaran_persentase = {
                    barchart_bank_charge:this.processBarChart(result.data.summary.pengeluaran_persentase.bank_charge, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_biaya_administrasi_bank:this.processBarChart(result.data.summary.pengeluaran_persentase.biaya_administrasi_bank, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_pajak_giro:this.processBarChart(result.data.summary.pengeluaran_persentase.pajak_giro, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_pengeluaran:this.processBarChart(result.data.summary.pengeluaran_persentase.pengeluaran, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                    barchart_pengeluaran_per_bank:this.processBarChart(result.data.summary.pengeluaran_persentase.pengeluaran_per_bank, "NamaPengeluaran", "", "Nilai", false, "Tahun", "", 1, 2, Rainbow, "Grup", [1], true),
                } */

                this.ytd.summary.piechart_pengeluaran_persentase = {
                    bank_charge:result.data.summary.pengeluaran_persentase_pie.bank_charge,
                    biaya_administrasi_bank:result.data.summary.pengeluaran_persentase_pie.biaya_administrasi_bank, 
                    pajak_giro:result.data.summary.pengeluaran_persentase_pie.pajak_giro, 
                    pengeluaran:result.data.summary.pengeluaran_persentase_pie.pengeluaran,
                    pengeluaran_per_bank:result.data.summary.pengeluaran_persentase_pie.pengeluaran_per_bank,
                }

            })
        },

        penerimaanLabel(data, type) {
            let labels = []; 
            //let data = this.ytd.penerimaan.penjualan_data;
            for (let i in data) {  
                if(labels.some(itm => itm.NamaPenerimaan === data[i].NamaPenerimaan)){
                    //console.log("Object found inside the array.");
                } else{
                    //console.log("Object not found. ");
                    labels.push(data[i]);
                } 
            }

            if(type === "penjualan") {
                this.penerimaan_label.penjualan = labels;
                //console.log("penjualan: " + JSON.stringify(this.penerimaan_label.penjualan));
            } 
            else if(type === "bunga_deposito") {
                this.penerimaan_label.bunga_deposito = labels;
                //console.log("bunga_deposito: " + JSON.stringify(this.penerimaan_label.bunga_deposito));
            } 
            else if(type === "bunga_notpool")
                this.penerimaan_label.bunga_notpool = labels;
            else if(type === "bunga_giro")
                this.penerimaan_label.bunga_giro = labels;
            else if(type === "persentase_penerimaan_penjualan")
                this.persentase_penerimaan_label.penjualan = labels;
            else if(type === "persentase_penerimaan_cash")
                this.persentase_penerimaan_label.cash = labels;
            else if(type === "persentase_penerimaan_non_cash")
                this.persentase_penerimaan_label.non_cash = labels;
            else if(type === "persentase_penerimaan_cash_per_day")
                this.persentase_penerimaan_label.cash_per_day = labels;
            else if(type === "persentase_penerimaan_non_cash_per_day")
                this.persentase_penerimaan_label.non_cash_per_day = labels;
            else if(type === "persentase_penerimaan_rata_rata_per_day")
                this.persentase_penerimaan_label.rata_rata_per_day = labels;
                
        },

        pengeluaranLabel(data, type) {
            let labels = []; 
            //let data = this.ytd.penerimaan.penjualan_data;
            for (let i in data) {  
                if(labels.some(itm => itm.NamaPengeluaran === data[i].NamaPengeluaran)){
                    //console.log("Object found inside the array.");
                } else{
                    //console.log("Object not found. ");
                    labels.push(data[i]);
                } 
            }

            if(type === "pengeluaran_data") {
                this.pengeluaran_label.pengeluaran = labels;
            } 
            else if(type === "pajak_notpool_data") {
                this.pengeluaran_label.pajak_notpool = labels;
            } 
            else if(type === "biaya_administrasi_bank_data")
                this.pengeluaran_label.biaya_administrasi_bank = labels;
            else if(type === "pajak_giro_data")
                this.pengeluaran_label.pajak_giro = labels;
            else if(type === "bank_charge_data")
                this.pengeluaran_label.bank_charge = labels;
            else if(type === "persentase_pengeluaran_data") //persentase pengeluaran
                this.persentase_pengeluaran_label.pengeluaran = labels;
            else if(type === "persentase_pengeluaran_per_bank_data")
                this.persentase_pengeluaran_label.pengeluaran_per_bank = labels;
            else if(type === "persentase_pengeluaran_biaya_administrasi_bank_data")
                this.persentase_pengeluaran_label.biaya_administrasi_bank = labels;
            else if(type === "persentase_pengeluaran_pajak_giro_data")
                this.persentase_pengeluaran_label.pajak_giro = labels;
            else if(type === "persentase_pengeluaran_bank_charge_data")
                this.persentase_pengeluaran_label.bank_charge = labels;
                
        },
       
				
	},
}
